module.exports = __webpack_public_path__ + "img/sld_mfm_ring_four.196119d8.svg";